import { Col, Row } from 'antd';
import CaracteristicaCard from "./CaracteristicaCard";
import _ from "lodash";


const Caracteristicas = ({ data }) => {
    let caracteristicas = _.orderBy(data, item => item.orden);
    caracteristicas = caracteristicas.slice(0, 2)

    return (
        <Row gutter={[15, 15]}>
            {caracteristicas.map(item =>
                <Col key={item.id} xs={12} sm={12} md={12} lg={8}>
                    <CaracteristicaCard {...item} />
                </Col>)}
        </Row>
    )
}

export default Caracteristicas;



